module.exports = __webpack_public_path__ + "img/sb3.b4173ef2.png";